export default "__VITE_ASSET__DuVFvvIW__"